"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = require("./config");

var shapes_top_1 = require("./shapes-top");

var shapes_shared_1 = require("./shapes-shared");

var shapes_front_1 = require("./shapes-front");

var utils_1 = require("./utils");

var shapes_side_1 = require("./shapes-side");

var translations_1 = __importDefault(require("./translations")); // Polyfill window.document


var document = utils_1.getDocument();

var SvgManager =
/** @class */
function () {
  function SvgManager(plateComponents, angle, container, language) {
    var _this = this;

    if (angle === void 0) {
      angle = 'top';
    }

    this.plateStartX = 0;
    this.plateStartY = 0;

    this.update = function (plateComponents) {
      // console.log('plateComponents', plateComponents);
      // Cleanup
      _this.clear(); // Saving plateComponents


      _this.plateComponents = JSON.parse(JSON.stringify(plateComponents)); // Flatten all getters, we have to do this so we can makeBirdseye for the sides xP

      _this.plateComponents.elements = _this.plateComponents.elements.filter(function (e) {
        return !e.hidden;
      });
      _this.plateComponents.additional = _this.plateComponents.additional.filter(function (e) {
        return !e.hidden;
      }); // Swap around y and z if it's top view...

      if (_this.angle === 'top') {
        _this.plateComponents = _this.swapYwithZ(_this.plateComponents);
      }

      if (_this.angle === 'side') {
        _this.plateComponents = _this.swapXwithZ(_this.plateComponents);
      }

      if (_this.angle === 'front' || _this.angle === 'side') {
        _this.plateComponents = _this.makeRealBottom(_this.plateComponents); // this.plateComponents.plate.sides.bottom = this.plateComponents.plate.sides.top + this.plateComponents.plate.scale.y;
      } // Normalizing to SVG viewport and adding padding


      var scale = _this.plateComponents.plate.scale.x; // Have to limit how much everything shrinks

      if (_this.plateComponents.plate.scale.x < 2700 && _this.angle !== 'side') {
        scale = 2700;
      }

      if (_this.plateComponents.plate.scale.x < 1000 && _this.angle === 'side') {
        scale = 1000;
      }

      var xNormalizedScale = (_this.angleConfig.canvas.scale.x - _this.angleConfig.canvas.padding.x * 2) / scale;
      var yNormalizedScale = (_this.angleConfig.canvas.scale.x - _this.angleConfig.canvas.padding.y * 2) / scale;
      plateComponents = _this.addNormalizations(_this.plateComponents, xNormalizedScale, yNormalizedScale); // Making positions and scales relative to viewbox (1000)
      // Calculate starting position of the plate... this is used to make other lines/shapes relative to plate

      _this.plateComponents = _this.makeElementsRelativeToCenter(_this.plateComponents); // Populate

      var sharedShapes = shapes_shared_1.createSharedShapes(plateComponents, _this.angleConfig.canvas);

      _this.draw(sharedShapes);

      if (_this.angle === 'top') {
        var topShapes = shapes_top_1.createTopShapes(plateComponents, _this.angleConfig.canvas);

        _this.draw(topShapes);
      }

      if (_this.angle === 'front') {
        var frontShapes = shapes_front_1.createFrontShapes(plateComponents, _this.angleConfig.canvas);

        _this.draw(frontShapes);
      }

      if (_this.angle === 'side') {
        var sideShapes = shapes_side_1.createSideShapes(plateComponents, _this.angleConfig.canvas);

        _this.draw(sideShapes);
      }
    };

    this.clear = function () {
      _this.view.innerHTML = '';
      config_1.state.top.xStep = 0;
    };

    this.swap = function (element, key1, key2) {
      if (typeof element.scale !== 'undefined') {
        var temp = element.scale[key2];
        element.scale[key2] = element.scale[key1];
        element.scale[key1] = temp;
      }

      if (typeof element.position !== 'undefined') {
        var temp = element.position[key2];
        element.position[key2] = element.position[key1];
        element.position[key1] = temp;
      }

      if (key1 === 'y' && key2 === 'z') {
        if (typeof element.sides !== 'undefined') {
          element.sides.top = element.sides.back;
          element.sides.bottom = element.sides.front;
        }

        if (typeof element.buffer !== 'undefined') {
          element.buffer.top = element.buffer.back;
          element.buffer.bottom = element.buffer.front;
        }
      }

      if (key1 === 'x' && key2 === 'z') {
        if (typeof element.sides !== 'undefined') {
          element.sides.left = element.sides.back;
          element.sides.right = element.sides.front;
        }

        if (typeof element.buffer !== 'undefined') {
          element.buffer.left = element.buffer.back;
          element.buffer.right = element.buffer.front;
        }
      }

      if (typeof element.elements !== 'undefined') {
        for (var _i = 0, _a = element.elements; _i < _a.length; _i++) {
          var child = _a[_i];
          child = _this.swap(child, key1, key2);
        }
      }

      return element;
    };

    this.swapYwithZ = function (plateComponents) {
      plateComponents.plate = _this.swap(plateComponents.plate, 'y', 'z');

      if (plateComponents.elements) {
        for (var _i = 0, _a = plateComponents.elements; _i < _a.length; _i++) {
          var element = _a[_i];
          element = _this.swap(element, 'y', 'z');
        }
      }

      if (plateComponents.additional) {
        for (var _b = 0, _c = plateComponents.additional; _b < _c.length; _b++) {
          var element = _c[_b];
          element = _this.swap(element, 'y', 'z');
        }
      }

      return plateComponents;
    };

    this.swapXwithZ = function (plateComponents) {
      plateComponents.plate = _this.swap(plateComponents.plate, 'x', 'z');

      if (plateComponents.elements) {
        for (var _i = 0, _a = plateComponents.elements; _i < _a.length; _i++) {
          var element = _a[_i];
          element = _this.swap(element, 'x', 'z');
        }
      }

      if (plateComponents.additional) {
        for (var _b = 0, _c = plateComponents.additional; _b < _c.length; _b++) {
          var element = _c[_b];
          element = _this.swap(element, 'x', 'z');
        }
      }

      return plateComponents;
    };

    this.addNormalizations = function (plateComponents, xNormalizedScale, yNormalizedScale) {
      var addNormalizationsToElement = function addNormalizationsToElement(element) {
        if (typeof element.scale !== 'undefined') {
          if (typeof element.nscale === 'undefined') {
            element.nscale = {};
          }

          element.nscale.z = element.scale.z * xNormalizedScale;
          element.nscale.x = element.scale.x * xNormalizedScale;
          element.nscale.y = element.scale.y * yNormalizedScale;
        }

        if (typeof element.position !== 'undefined') {
          if (typeof element.nposition === 'undefined') {
            element.nposition = {};
          }

          element.nposition.z = element.position.z * xNormalizedScale;
          element.nposition.x = element.position.x * xNormalizedScale;
          element.nposition.y = element.position.y * yNormalizedScale;
        }

        if (typeof element.sides !== 'undefined') {
          if (typeof element.nsides === 'undefined') {
            element.nsides = {};
          }

          element.nsides.top = element.sides.top * yNormalizedScale;
          element.nsides.bottom = element.sides.bottom * yNormalizedScale;
          element.nsides.front = element.sides.front * yNormalizedScale;
          element.nsides.back = element.sides.back * yNormalizedScale;
          element.nsides.left = element.sides.left * xNormalizedScale;
          element.nsides.right = element.sides.right * xNormalizedScale;
        }

        if (typeof element.buffer !== 'undefined') {
          if (typeof element.nbuffer === 'undefined') {
            element.nbuffer = {};
          }

          element.nbuffer.front = element.buffer.front * yNormalizedScale;
          element.nbuffer.back = element.buffer.back * yNormalizedScale;
          element.nbuffer.left = element.buffer.left * xNormalizedScale;
          element.nbuffer.right = element.buffer.right * xNormalizedScale;
        }

        if (typeof element.elements !== 'undefined') {
          for (var _i = 0, _a = element.elements; _i < _a.length; _i++) {
            var child = _a[_i];
            child = addNormalizationsToElement(child);
          }
        }

        return element;
      }; // Plate


      plateComponents.plate = addNormalizationsToElement(plateComponents.plate); // Elements

      if (plateComponents.elements) {
        for (var _i = 0, _a = plateComponents.elements; _i < _a.length; _i++) {
          var element = _a[_i];
          element = addNormalizationsToElement(element);
        }
      } // Additional


      if (plateComponents.additional) {
        for (var _b = 0, _c = plateComponents.additional; _b < _c.length; _b++) {
          var addition = _c[_b];
          addition = addNormalizationsToElement(addition);
        }
      }

      return plateComponents;
    };

    this.makeElementsRelativeToCenter = function (plateComponents) {
      var plateStartX = _this.angleConfig.canvas.center.x - _this.plateComponents.plate.nscale.x / 2;
      var plateStartY = _this.angleConfig.canvas.center.y - _this.plateComponents.plate.nscale.y / 2 - plateComponents.plate.nsides.top;

      var makeElementRelativeToPlate = function makeElementRelativeToPlate(element) {
        element.nposition.x = plateStartX + element.nposition.x;
        element.nposition.y = plateStartY + element.nposition.y;
        element.nsides.left = plateStartX + element.nsides.left;
        element.nsides.right = plateStartX + element.nsides.right;
        element.nsides.top = plateStartY + element.nsides.top;
        element.nsides.bottom = plateStartY + element.nsides.bottom;

        if (typeof element.elements !== 'undefined') {
          for (var _i = 0, _a = element.elements; _i < _a.length; _i++) {
            var child = _a[_i];
            child = makeElementRelativeToPlate(child);
          }
        }

        return element;
      }; // Elements


      if (plateComponents.elements) {
        for (var _i = 0, _a = plateComponents.elements; _i < _a.length; _i++) {
          var element = _a[_i];
          element = makeElementRelativeToPlate(element);
        }
      } // Additional


      if (plateComponents.additional) {
        for (var _b = 0, _c = plateComponents.additional; _b < _c.length; _b++) {
          var addition = _c[_b];
          addition = makeElementRelativeToPlate(addition);
        }
      }

      makeElementRelativeToPlate(plateComponents.plate);
      return plateComponents;
    };

    this.makeRealBottom = function (plateComponents) {
      // We have a strange problem... basically, all the y scales were zeroed to the ground, but when placing things on a canvas the opposite is true
      // Things are getting shifted around... because the center is still on the opposite side even if I adjust it here, aggggggffg
      // I have to mirror the centers first, and the center is the plate, so everything has to be relative to the plate
      // plate.position.y = 1000
      // console.position.y = 900... must become 1100
      // 1000 - 900 = 100 * 2 = 200 + 900 = 1100
      var center = plateComponents.plate.position.y;

      var swap = function swap(element) {
        if (typeof element.position !== 'undefined') {
          var difference = center - element.position.y;
          element.position.y = element.position.y + difference * 2;
        }

        if (typeof element.sides !== 'undefined') {
          element.sides.top = element.position.y - element.scale.y / 2;
          element.sides.bottom = element.position.y + element.scale.y / 2;
        }

        if (typeof element.elements !== 'undefined') {
          for (var _i = 0, _a = element.elements; _i < _a.length; _i++) {
            var child = _a[_i];
            child = swap(child);
          }
        }

        return element;
      };

      plateComponents.plate = swap(plateComponents.plate);

      if (plateComponents.elements) {
        for (var _i = 0, _a = plateComponents.elements; _i < _a.length; _i++) {
          var element = _a[_i];
          element = swap(element);
        }
      }

      if (plateComponents.additional) {
        for (var _b = 0, _c = plateComponents.additional; _b < _c.length; _b++) {
          var element = _c[_b];
          element = swap(element);
        }
      }

      return plateComponents;
    };

    this.draw = function (shapes) {
      if (!shapes || Array.isArray(shapes) && shapes.length === 0) {
        return;
      }

      if (Array.isArray(shapes)) {
        shapes = _this.flatten(shapes); // shapes = this.moveNodeToFront(shapes, 'image');

        shapes = _this.moveIntersectionsToBack(shapes);
        shapes = _this.moveNodeToFront(shapes, 'text');
        shapes.forEach(function (shape) {
          _this.draw(shape);
        });
      } else {
        _this.view.appendChild(shapes);
      }
    };

    this.flatten = function (items) {
      var flat = [];
      items.forEach(function (item) {
        if (Array.isArray(item)) {
          flat.push.apply(flat, _this.flatten(item));
        } else {
          flat.push(item);
        }
      });
      return flat;
    };

    this.moveIntersectionsToBack = function (items) {
      // Sometimes rectangles overlap when we don't want them to... solution is to mark it as intersection with an additional rectangle to act as cover
      var intersecting = items.filter(function (item) {
        return item.getAttribute('data-intersectfix');
      });
      var withoutIntersection = items.filter(function (item) {
        return !item.getAttribute('data-intersectfix');
      });
      return intersecting.concat(withoutIntersection);
    };

    this.moveNodeToFront = function (items, nodeName) {
      items.map(function (current, idx, obj) {
        if (current.nodeName === nodeName) {
          obj.push(obj[idx]);
          obj.splice(idx, 1);
        }

        return obj;
      });
      return items;
    }; // Defaults


    if (!container) {
      this.container = document.getElementById('container') || document.createElement('div');
    } else {
      this.container = container;
    }

    if (!language) {
      language = 'en';
    }

    translations_1.default.language = language; // How can I make language a global variable? window.bla would work
    // Any other better method?
    // Side/angle

    this.angle = angle; // angle;

    this.angleConfig = config_1.config[this.angle]; // Creating SVG

    this.view = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this.view.setAttribute('viewBox', "0 0 " + this.angleConfig.canvas.scale.x + " " + this.angleConfig.canvas.scale.y);
    this.container.appendChild(this.view); // Just call update to populate everything...

    this.update(plateComponents);
  }

  return SvgManager;
}();

exports.SvgManager = SvgManager;